import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
// import ReactPaginate from 'react-paginate';
import $ from 'jquery';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {hashHistory} from "react-router";
import {FormattedMessage} from "react-intl";

import store from './../../store';
import {UserPopupTypes} from "../visComponents/constants";

import {
  setSelectionWindowView,
  toggleSelectionFeatureInfo,
  toggleBathroomVisualizerOpen,
  toggleUserPopup,
  setActiveFeature, setBathroomVisualizerVisited,
} from "../../actions/actionFunctions";
import FeatureInfo from './selectionFeatureInfo/featureInfo';
import SelectionMainList from './selectionMainList';

import {browserIsSafari} from "../../misc/helpers";

import {PartMenuType} from "../visComponents/constants";
import {getCurrentCanvas, getCurrentLayout} from "../appLayout";
import HomeButton from '../ui/homeButton';
import Gallery from './gallery';
import Analytics from './../../analytics';
// import UserLoginButton from "../ui/userLoginButton";
import SelectionDescriptionCover from "./selectionDescriptionCover";
import ExpandVisualizerMethods from "./expandVisualizerMethods";
import {showVisualizerTutorial} from "../../actions/tutorialFunctions";
import {setInitialFlowType} from "../../actions/initialFlowFunctions";
import {INITIAL_FLOW_BUTTON_TYPES} from "../../reducers/initialFlowReducer";
import ActionTypes from "../../misc/actionTypes";
import NotInVisualizerView from "./notInVisualizerView";
import NotCompatibleView from "./notCompatibleView";
import MobileMenu from "../ui/mobileMenu";
import {toggleGalleryVisible, setMaterialsCanvasClass, setMaterialsCanvasLoading} from "../../actions/selectionFunctions";
// import CoBrowsingButton from "../ui/coBrowsingButton";
import PingPilotButton from "../visComponents/pingPilotButton";
import HardcodedCanvasImage from "../visComponents/hardcodedCanvasImage";
import NoInternetOverlay from "../ui/noInternetOverlay";
import SelectionMainHeader from "./selectionMainHeader";
import LoadingSpinner from "../ui/loadingSpinner";
import {USE_NEW_CANVAS} from "../../config";
import MaterialsMainLoading from "../qkbPages/materialsCommon/materialsMainLoading";


class SelectionMain extends ExpandVisualizerMethods {

  static propTypes = {
    activeSubPart: PropTypes.object.isRequired,
    activePart: PropTypes.object,
    searchText: PropTypes.string.isRequired,
    handleSearchInputChange: PropTypes.func.isRequired,
    handleCloseClick: PropTypes.func.isRequired,
    changeActivePartRelatedItem: PropTypes.func.isRequired,
    features: PropTypes.array.isRequired,
    updateComponent: PropTypes.func,
    checkIfNeedToSwitchRoom: PropTypes.func,
    searchRequest: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      paginationOffset: 0,  // start from 0, show items from 0 to featuresPerPage
      currentPage: 0,
      pageCount: 50, // max buttons in pagination shown
      featuresPerPage: 10,
      mobileSearch: false,
      listItemHeight: 0,
      showItemsList: false,
      height: 0,
      canvasExpanding: false,
      canvasCollapsing: false
    };
    this.itemsList = null;
    this.resizeId = 0;
    this.needToRefreshItems = false;  // only needed after returning to the list view
    this._ismounted = true;
    // last partId pushed to selectionState.materialsCanvasClass (see syncMaterialsCanvasClass) —
    // undefined so the very first sync in componentDidMount always dispatches.
    this._lastMaterialsCanvasClass = undefined;
  }

  componentDidMount() {
    this.setActiveFeature();
    this.syncMaterialsCanvasClass();
    $(window).on('resize', this.handleResize);
    $(window).on(ActionTypes.UPDATE_ALL_ITEMS, this.handleRefresh);
    this.checkIfNeedToSwitchListView();
    if (browserIsSafari()) {
      window.addEventListener('scroll', this.handleResize);
      setTimeout(function(){
        // Hide the address bar!
        window.scrollTo(0, 1);
      }, 0);
    }
    $(window).on(ActionTypes.CHANGE_LAYOUT, () => {
      if (this._ismounted) {
        this.forceUpdate();
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ((nextProps.activePart.partName !== this.props.activePart.partName)
      || (nextProps.activeSubPart && (nextProps.activeSubPart.part.partName !== this.props.activeSubPart.part.partName))) {
      this.setActiveFeature(null, nextProps);
      this.checkViewType(nextProps);
    }
    // Docked-canvas auto-zoom (useZoomToActiveFeatureGroup) reads
    // selectionState.materialsCanvasClass to know which feature group to frame — the wizard flow
    // keeps that in sync via materialsWizardMain.js's setNewCanvasClass, but this non-wizard flow
    // (selectionWindow/selectionMain) never wrote to it at all, so the canvas never zoomed here.
    // syncMaterialsCanvasClass itself only dispatches when the computed partId actually changes
    // (see its own dedupe), so this call is cheap on every props update, not just part changes.
    this.syncMaterialsCanvasClass(nextProps);
    setTimeout(() => {
      // console.log('!', nextProps);
      if (!nextProps.activeSubPart.part.activeFeature) {
        nextProps.activeSubPart.part.setDefault()
      }
      // const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;
    }, 0);
    if (this.needToRefreshItems
      || (!this.state.listItemHeight && !nextProps.isMobile && (!nextProps.selectionFeatureInfo && this.props.selectionFeatureInfo))) {
      this.handleResize();
      this.needToRefreshItems = false;
    }
    if (nextProps.selectionWindowView !== this.props.selectionWindowView && !nextProps.isMobile) {
      this.setState({
        showItemsList: false
      });
      setTimeout(() => {
        if (this._ismounted) {
          this.setDesktopItemHeight();
        }
      }, 0)
    }
    if (this.props.bvOpened && !nextProps.bvOpened) {
      this.cameFromBV()
    } else if (nextProps.materialsTutorialStep === 1 && !this.props.materialsTutorialStep) {
      this.goToBV();
    }
  }

  handleResize = () => {
    this.setState({
      showItemsList: false
    });
    clearTimeout(this.resizeId);
    this.resizeId = setTimeout(this.checkIfNeedToSwitchListView, 500);
  };

  componentWillUnmount() {
    $(window).off('resize', this.handleResize);
    $(window).off(ActionTypes.CHANGE_LAYOUT);
    $(window).off(ActionTypes.UPDATE_ALL_ITEMS, this.handleRefresh);
    if (browserIsSafari()) {
      window.removeEventListener('scroll', this.handleResize)
    }
    this._ismounted = false;
  }

  handleRefresh = () => {
    if (!this._ismounted) {
      return
    }
    this.forceUpdate();
  };

  checkViewType = (nextProps = this.props) => {
    const {isMobile} = nextProps;
    const checkPart = nextProps.activeSubPart || nextProps.activePart;

    if (checkPart && checkPart.part) {
      if (isMobile && (!checkPart.part.displayType || checkPart.part.displayType === 3)) {
        if (nextProps.selectionWindowView !== 2) {
          this.props.handleChangeListView(2); // mobile set
        }
      } else if (checkPart.part.displayType && (checkPart.part.displayType !== nextProps.selectionWindowView)) {
        this.props.handleChangeListView(checkPart.part.displayType); // from part
      } else if (!checkPart.part.displayType && (nextProps.selectionWindowView !== 3)) {
        this.props.handleChangeListView(3); // default
      }
    } else if (isMobile && this.props.selectionWindowView === 3) {
      this.props.handleChangeListView(2);
    }
  };

  checkIfNeedToSwitchListView = () => {
    this.checkViewType();
    const {isMobile} = this.props;
    if (isMobile) {
      setTimeout(() => {
        // console.log($(this.refs.itemsList).height());
        this.setState({
          listItemHeight: $(this.itemsList).height(),
          showItemsList: true
        })
      }, 0);
    } else {
      setTimeout(() => {
        this.setDesktopItemHeight();
      }, 0);
    }
    if (this.props.selectionFeatureInfo || this.props.bvOpened) {
      this.needToRefreshItems = true;
    }
    this.setState({
      height: window.innerHeight + document.body.scrollTop
    })
  };

  setDesktopItemHeight() {
    if (!this._ismounted) {
      return
    }
    let widthPercentage = 0;
    switch(this.props.selectionWindowView) {
      case 1:
        widthPercentage = 32.3;
        break;
      case 2:
        widthPercentage = 24;
        break;
      case 3:
        widthPercentage = 19;
        break;
      default:
        widthPercentage = 32.3;
        break;
    }
    const listItemHeight = $(this.itemsList).width()*widthPercentage/100;
    this.setState({
      listItemHeight,
      showItemsList: true
    })
  }

  handleChangeListView = (e) => {
    Analytics.sendClickEvent("change-list-view-" + e.target.dataset.view);
    this.props.handleChangeListView(+e.target.dataset.view);
  };

  handleFeatureClick = (activeFeature) => {
    activeFeature.part.handleClick();
    this.props.setActiveFeature(activeFeature.part);
    // console.log('is visible', $('.feature--selected').is(':visible'));
  };

  toggleMobileButton = (activeFeature) => {
    this.setState({
      [activeFeature]: !this.state[activeFeature]
    })
  };

  handleUserLoginClick = (userPopupType = UserPopupTypes.Unlock) => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    const getQuoteEnabled = fabricatorSettings.enableQuote;
    Analytics.sendClickEvent(getQuoteEnabled ? 'get-quote-feature-selection' : 'user-login');
    if (this.props.userIsLoggedIn) {
      if (fabricatorSettings.twoFA) {
        if (!this.props.isPhoneNumberValidated) {
          this.props.toggleUserPopup({
            userPopupOpened: true,
            userPopupType
          });
        } else {
          this.toggleMobileButton('userLogoutActive');
        }
      } else {
        this.toggleMobileButton('userLogoutActive');
      }
    } else {
      this.props.toggleUserPopup({
        userPopupOpened: true,
        userPopupType
      });
    }
  };

  setActiveFeature = (activeFeature = null, props = this.props) => {

    // const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;
    if (!activeFeature) {
      const currentParent = this.getCurrentParent(props);
      const fabricatorSettings = this.props.fabricatorData.settings;
      activeFeature = ((fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote))
        && !this.props.userIsLoggedIn && currentParent.activeLockedFeature)
      || ((fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote))
        && this.props.userIsLoggedIn
        && currentParent.activeLockedFeature
        && !currentParent.placeholderChanged)
        ? currentParent.activeLockedFeature
        : currentParent.activeFeature
          ? currentParent.activeFeature
          : currentParent.activeNotInVisualizerFeature && currentParent.firstClick[props.activeQuoteIndex]
            ? currentParent.activeNotInVisualizerFeature
            : null
    }

    this.props.setActiveFeature(activeFeature);
  };

  getCurrentParent = (props = this.props) => {
    return props.activePart.menuType === PartMenuType.Complex
      ? props.activeSubPart.part
      : props.activePart;
  };

  setRef = (ref) => {
    this.itemsList = ref;
  };

  handleToggleLayout = () => {
    this.props.setInitialFlowType(INITIAL_FLOW_BUTTON_TYPES.Quote);
    hashHistory.push("layout");
  };

  enableLoader = () => {
    this.props.setMaterialsCanvasLoading(true);
    store.dispatch(showLoading());
  };

  disableLoader = () => {
    this.props.setMaterialsCanvasLoading(false);
    store.dispatch(hideLoading());
  };

  backsplashSelectClick = () => {
    $(window).trigger('resize');
    $(window).trigger(ActionTypes.UPDATE_QUOTING_TOOL);
  };

  getZoomingPartId = (props = this.props) => {
    const {activeSubPart, features, qtActiveCategory, activePartRelatedItemIndex} = props;
    if (!activeSubPart) {
      return ""
    }
    if (features.length && features.every(navItem => navItem.part.notAvailableInVisualizer) && activePartRelatedItemIndex > 0) {
      const layout = getCurrentLayout();
      if (layout.qtCategories && qtActiveCategory) {
        let qtCategory = layout.qtCategories.find(qtCategory => qtCategory.name === qtActiveCategory);
        if (qtCategory) {
          const subParts = qtCategory.subParts;
          if (subParts.length) {
            for (let i = activePartRelatedItemIndex - 1; i > - 1; i--) {
              if (subParts[i]) { // just in case
                const navItemsForPrevParent = layout.designNavigationItems(subParts[i],[], "",true, false);
                if (navItemsForPrevParent.length && navItemsForPrevParent.some(navItem => !navItem.part.notAvailableInVisualizer)) {
                  return subParts[i].part.partId
                }
              }
            }
          }
        }
      }
    }
    return activeSubPart.part.partId
  }

  // Pushes getZoomingPartId()'s result into selectionState.materialsCanvasClass, but only when it
  // actually changed since the last push — same "only re-run at the feature-group granularity, not
  // per click" guarantee materialsWizardMain.js's setNewCanvasClass gives the wizard flow. Safe to
  // call on every props update (see UNSAFE_componentWillReceiveProps): the dedupe below, not the
  // caller, decides whether a dispatch actually happens.
  syncMaterialsCanvasClass = (props = this.props) => {
    if (!USE_NEW_CANVAS) {
      return;
    }
    const zoomingPartId = this.getZoomingPartId(props);
    if (zoomingPartId === this._lastMaterialsCanvasClass) {
      return;
    }
    this._lastMaterialsCanvasClass = zoomingPartId;
    props.setMaterialsCanvasClass(zoomingPartId);
  }

  renderCanvasPosition = (layers, layout) => {
    const {visualizerNotAvailable, isMobile, activeFeature, canvasDimensions, staticCanvasImage,
      visualizerIsChanging} = this.props;
    if (staticCanvasImage) {
      return null
    }
    if (visualizerNotAvailable) {
      return <NotInVisualizerView goToBV={this.goToBV}
                                  isMobile={isMobile}
                                  listItemHeight={this.state.listItemHeight}
                                  allVisualizerNotAvailable={true}
                                  activeFeature={activeFeature}/>
    }
    if (visualizerIsChanging) {
      return <LoadingSpinner/>
    }
    const ImageCanvas = getCurrentCanvas();
    return (
      <ImageCanvas canvasId="selectionCanvas"
                   layers={layers}
                   width={canvasDimensions.width}
                   height={canvasDimensions.height}
                   layoutType={layout.getCurrentLayoutName()}
                   layout={layout}
                   useMouseHovering={false}
                   enableLoader={this.enableLoader}
                   disableLoader={this.disableLoader}
      />
    )
  };

  render() {
    const layout = getCurrentLayout();
    // const availableButtons = Math.ceil(this.props.features.length / this.props.featuresPerPage);
    // const maxButtons = (availableButtons > this.state.pageCount) ? this.state.pageCount : availableButtons;
    const {isBackend, jobId, canSaveQuote} = document.kvConfig;
    const {activeSubPart, activeFeature, fabricatorData, isMobile} = this.props;
    const fabricatorSettings = fabricatorData.settings;

    const layoutAbbr = layout.getCurrentLayoutAbbreviation().toLowerCase();

    const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;

    const mobileSafari = isMobile && browserIsSafari();
    const selectionBodyStyles = mobileSafari ? { height: this.state.height - 90 } : {};

    const firstClickDone = activeFeature && activeFeature.getParent().firstClick[this.props.activeQuoteIndex];

    const showLockScreen = firstClickDone
      && !activeFeature.dbFeature.unlocked
      && (fabricatorSettings.leadCaptureOnQuote && !(isBackend && jobId && canSaveQuote))
      && !this.props.isPhoneNumberValidated && !fabricatorSettings.leadCaptureShoppingCart;

    // const {dbFeature} = activeFeature || {};
    const showHomeButton = !this.state.canvasExpanding && isMobile;
    // const showGalleryButton = activeFeature && !this.props.selectionFeatureInfo && !this.state.canvasExpanding
    //  && dbFeature.galleryImages && dbFeature.galleryImages.length;
    const showGalleryButton = false;

    const getQuoteEnabled = fabricatorSettings.enableQuote;

    const showVisualizerExpandButton = !this.state.canvasExpanding && !this.props.visualizerNotAvailable
      && (!fabricatorSettings.leadCaptureShoppingCart || (fabricatorSettings.leadCaptureShoppingCart && this.props.isPhoneNumberValidated)
        || (fabricatorSettings.leadCaptureShoppingCart && document.kvConfig.visualizerEntered))
      && !(fabricatorSettings.useCategorySwitching && this.props.staticCanvasImage)

    const layers = layout.getLayers(showPlaceHolders);

    const showNotInVisualizerView = !showLockScreen && !this.state.canvasExpanding && firstClickDone && activeFeature
      && activeFeature.notAvailableInVisualizer && !this.props.visualizerNotAvailable && !fabricatorData.isCaesarStone;

    const showNotCompatibleView = !showLockScreen && !this.state.canvasExpanding && firstClickDone && activeFeature
      && !activeFeature.notAvailableInVisualizer && !this.props.visualizerNotAvailable && this.props.showNotCompatibleView;


    const canvasClass = "selection-main__image selection-main__image--" + document.kvConfig.visualizerType
      + " selection-main__image--"+layoutAbbr
      + " selection-main__image--scene-"+layout.scene
      + " selection-main__image--"+this.getZoomingPartId()
      + (this.state.canvasExpanding ? " selection-main__image--expanding" : "")
      + (this.state.canvasCollapsing ? " selection-main__image--collapsing" : "")
      + (!layers.length || layers.length === 1 ? " selection-main__image--no-layers" : "");

    return (
      <div className="selection-body" style={selectionBodyStyles}>
        <div className="selection-main">
          <div className="materials-left">
            <NoInternetOverlay/>
            <div className={canvasClass} style={this.state.canvasImageStyles}>
              <HardcodedCanvasImage disableLoader={this.disableLoader}
                                    enableLoader={this.enableLoader}/>
              {this.renderCanvasPosition(layers, layout)}
              <MaterialsMainLoading/>
              {/*{!showLockScreen && activeFeature && activeFeature.notAvailableInVisualizer ? (*/}
                {/*<div className="selection-main__image-img"*/}
                     {/*style={{...styleBkgImage(s3FeatureImagePath(activeFeature.dbFeature))}}/>*/}
              {/*) : null}*/}
              {!showLockScreen && !this.state.canvasExpanding && activeSubPart && this.props.features.length
                ? <SelectionDescriptionCover activePart={activeSubPart}/>
                : null}
              {showLockScreen && !this.state.canvasExpanding && !this.props.visualizerNotAvailable ? (
                <div className="lock">
                  <span className="lock-icon"/>
                  <p className="lock-text bold"><FormattedMessage id="quotingTool.canvas.featureIsLocked"/></p>
                  <button className="lock-button ui-button3 ui-button3--green" onClick={() => this.handleUserLoginClick(
                    getQuoteEnabled ? UserPopupTypes.GetQuote : UserPopupTypes.Unlock
                  )}>
                    {getQuoteEnabled
                      ? <FormattedMessage id="quotingTool.canvas.getQuoteButton"/>
                      : <FormattedMessage id="quotingTool.canvas.unlockNowButton"/>}
                  </button>
                </div>
              ) : null}
              {showNotInVisualizerView ? (
                <NotInVisualizerView goToBV={this.goToBV}
                                     isMobile={isMobile}
                                     listItemHeight={this.state.listItemHeight}
                                     activeFeature={activeFeature}/>
              ) : null}
              {showNotCompatibleView ? <NotCompatibleView /> : null}
              {showHomeButton ?
                this.props.mobileNav && this.props.mobileNav.length > 0
                  ? <MobileMenu smallButton={true}
                                smallButtonClassName={"selection-main__image-button selection-main__image-button--home"}/>
                  : <HomeButton className="scart-canvas__button scart-canvas__button--home" />
                : null}
              {/*activeFeature && activeFeature.vanitySize
                ? <span className="selection-main__image-size bold">{activeFeature.vanitySize}"</span>
              : null*/}
              {/*{activeFeature && !this.state.canvasExpanding && !this.props.selectionFeatureInfo*/}
              {/*  ? <button className="selection-main__image-button selection-main__image-button--info" onClick={this.goToFeatureInfo}/>*/}
              {/*  : null}*/}
              {showVisualizerExpandButton ? (
                <button className="selection-main__image-button selection-main__image-button--fullscreen" onClick={this.goToBV}/>
              ) : null}
              {/*{showGalleryButton*/}
              {/*  ? <button className="selection-main__image-button selection-main__image-button--image"*/}
              {/*            onClick={() => this.props.toggleGalleryVisible(true)}/>*/}
              {/*  : null}*/}
              {/*{fabricatorData.isAmericanImport && window.location.href.includes("quotekandb") ? <CoBrowsingButton/> : null}*/}
              <PingPilotButton/>
              {document.kvConfig.initialFlowEnabled && !this.props.visualizerNotAvailable
                ? <button className={"selection-main__image-button selection-main__image-button--layout"
                + (showHomeButton ? " selection-main__image-button--layout--with-home" : "")
                + (showGalleryButton ? " selection-main__image-button--layout--with-gallery" : "")}
                          onClick={this.handleToggleLayout}/>
                : null}
            </div>
          </div>

          {this.props.selectionFeatureInfo ? (
            <FeatureInfo
              features={this.props.features}
              handleFeatureClick={this.handleFeatureClick}
              activePart={this.props.activePart}
              changeActivePartRelatedItem={this.props.changeActivePartRelatedItem}
            />
          ) : (
            <div id="selection-main__bv-item" className="selection-main__bv-item">
              <SelectionMainHeader handleSearchInputChange={this.props.handleSearchInputChange}
                                   searchText={this.props.searchText}
                                   activeSubPart={activeSubPart}/>
              <div className="bv-item-container">
                <SelectionMainList
                  setRef={this.setRef}
                  currentParent={this.getCurrentParent()}
                  features={this.props.features}
                  listItemHeight={this.state.listItemHeight}
                  showItemsList={!this.props.searchRequest && this.state.showItemsList}
                  handleUserLoginClick={this.handleUserLoginClick}
                  layoutName={layout.getCurrentLayoutName()}
                  parentUpdate={this.props.parentUpdate}
                  checkIfNeedToSwitchRoom={this.props.checkIfNeedToSwitchRoom}
                />
              </div>
            </div>
          )}
        </div>
        {/*{!this.props.selectionFeatureInfo && (this.props.features.length > this.props.featuresPerPage) ? (*/}
        {/*  <div className="selection-pagination">*/}
        {/*    <ReactPaginate previousLabel={"Previous"}*/}
        {/*                   nextLabel={"Next"}*/}
        {/*                   breakLabel={<a href="">...</a>}*/}
        {/*                   breakClassName={"break-me"}*/}
        {/*                   forcePage={this.state.currentPage}*/}
        {/*                   pageCount={maxButtons}*/}
        {/*                   marginPagesDisplayed={2}*/}
        {/*                   pageRangeDisplayed={2}*/}
        {/*                   onPageChange={this.handlePaginateClick}*/}
        {/*                   containerClassName={"pagination"}*/}
        {/*                   subContainerClassName={"pages pagination"}*/}
        {/*                   activeClassName={"active"} />*/}
        {/*  </div>*/}
        {/*) : null}*/}
        {activeFeature && this.props.galleryVisible ? <Gallery/> : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {bvOpened, bvVisited, canvasDimensions, staticCanvasImage} = store.bathroomVisualizerState;
  const {galleryVisible, selectionGroup, selectionOpened, selectionWindowView, selectionFeatureInfo,
    activeFeature, showNotCompatibleView, activePartRelatedItemIndex} = store.selectionState;
  const {isMobile, visualizerIsChanging} = store.serverState;
  const {qtActiveCategory} = store.qtState;
  return {
    bvOpened,
    bvVisited,
    canvasDimensions,
    staticCanvasImage,
    selectionGroup,
    selectionOpened,
    selectionWindowView,
    selectionFeatureInfo,
    activeFeature,
    galleryVisible,
    showNotCompatibleView,
    activePartRelatedItemIndex,
    qtActiveCategory,
    cartItems: store.cartState.cartItems,
    userIsLoggedIn: store.userState.userIsLoggedIn,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    isMobile,
    fabricatorData: store.fabricatorState,
    materialsTutorialStep: store.tutorialState.materialsTutorialStep,
    visualizerTutorialFinished: store.tutorialState.visualizerTutorialFinished,
    visualizerNotAvailable: store.initialFlowState.visualizerNotAvailable,
    mobileNav: store.navigationState.mobileNav,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    visualizerIsChanging,
  };
};

const mapDispatchToProps = {
  handleChangeListView: setSelectionWindowView,
  toggleSelectionFeatureInfo,
  toggleUserPopup,
  toggleBathroomVisualizerOpen,
  setActiveFeature,
  setBathroomVisualizerVisited,
  showVisualizerTutorial,
  setInitialFlowType,
  toggleGalleryVisible,
  setMaterialsCanvasClass,
  setMaterialsCanvasLoading
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMain);
